howspace.components.widgetDescription = (() => {
    const findDescriptions = elem => elem.findIncludingSelf('.widget-description')
        .filter((_, description) => $(description).closest('.widget').length > 0);
    const translationEvent = howspace.components.translator.TRANSLATION_COMPLETED + '.widgetDescriptionTables';

    const wrapTables = description => {
        description.find('table').each(function () {
            const table = $(this);
            if (table.parent().hasClass('widget-description-table-scroll')) return;

            table.wrap($('<div>', {
                class: 'widget-description-table-scroll',
                tabindex: 0,
                role: 'region',
                'aria-label': howspace.translate('common_description')
            }));
        });
    };

    return {
        init: elem => {
            findDescriptions(elem).each(function () {
                const description = $(this);
                wrapTables(description);
                description.off(translationEvent).on(translationEvent, () => wrapTables(description));
            });
        },
        destroy: elem => {
            findDescriptions(elem).off(translationEvent);
        }
    };
})();
